import React, { memo } from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { BenefitsBento } from '../components/BenefitsBento';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { NovaSection } from '../components/nova/NovaSection';
import { StaticConnectionsBeat } from '../components/StaticConnectionsBeat';
import { TwelveTabProblem } from '../components/TwelveTabProblem';
import { WorkYouCantGetTo } from '../components/WorkYouCantGetTo';
import { ContextGraph } from '../components/ContextGraph';
import { MemoryCarousel } from '../components/MemoryCarousel';
// New Giga home screen. The hero is the "Ask Giga anything, get it done."
// chat-box composer (HowItWorksConnections in hero mode), presented as a
// proper website hero. The Slack "@mention Giga" experience remains its own
// "Works where you work" section further down the page.
// The "AI Co-Pilot for Teams" homepage still lives at /future.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-9449" data-mp="2d5vz9ovc1cax" />
      {/* <NovaSection /> Hidden per user request */}
      {/* "What Giga can do" overview — the bento leads the page right after the
                                               hero so cold ad/UGC traffic gets the answer ("what is this, and it
                                               actually does the work") before anything else. */}
      {/* "AI adoption fails without an AI brain" capability grid. Hidden for
                                               now per request; may return later. Import + component are preserved so
                                               no data is lost — just re-enable the <CapabilityGrid /> below.
                                               <CapabilityGrid /> */}
      <BenefitsBento data-id="element-9450" data-mp="1fmp2kq3gq70w" />
      {/* Problem statement as a CONTRAST beat — "the world without Giga" (11
                                                       tabs / context-switch tax). Placed right after the bento "what it
                                                       is" so it reframes the pain the ad already sold, then hands off to
                                                       the easy 2-minute setup. Leading with the answer (not the problem)
                                                       is intentional for ad/UGC traffic that arrives pre-sold on the pain. */}
      <TwelveTabProblem data-id="element-9451" data-mp="2r1ul93jzog65" />
      {/* Bridge beat — "Giga lives in the chats." Shows Giga answering right
                                                       inside Slack (reactive: it answers when asked), setting up the
                                                       proactive autonomy payoff later in the page. */}
      <LivesInSlack data-id="element-9452" data-mp="odmar9e4t5ka" />
      {/* "How it works" / Plug-and-play — the relief that follows the problem
                                                       beat, before the Giga for You / Team audience switch. */}
      <GettingStartedSteps data-id="element-9453" data-mp="3sugclbwxj5wp" />
      <AudienceSwitch data-id="element-9454" data-mp="3ntiuezbx6bv7" />
      {/* StaticConnectionsBeat ("Shared intelligence across your stack") removed
                                               from the home flow — its logo marquee + "See all integrations" CTA was a
                                               redundant third take on integration breadth (already covered by the hero
                                               marquee and the bento "Connects in seconds" card). Import preserved for
                                               reuse: <StaticConnectionsBeat /> */}

      {/* Data foundation — "Powered by your personal context graph." A dark,
                           premium beat showing every tool's data pulled into ONE interconnected
                           graph. */}
      <ContextGraph data-id="element-9455" data-mp="2harij584l9b3" />

      {/* The "Brain" beat — proves HOW Giga can do proactive work (because it
                           remembers everything). Sets up the automations gallery perfectly. */}
      <MemoryCarousel data-id="element-9456" data-mp="2qchaqd9u0c9x" />

      {/* "Nothing slips through the cracks" closer hidden again per request —
                           kept for easy re-enable: <WorkYouCantGetTo /> */}

      {/* Finale energy ramp: calm cream proof (WorkYouCantGetTo) → calm cream
                                                 social proof (WallOfLove) → bold orange founder conviction
                                                 (NarrativeSection) → dark confident close (ClosingCTA). WallOfLove now
                                                 sits BEFORE the founder beat so the bright orange reads as a deliberate
                                                 crescendo right before the dark CTA, not an interruption between two
                                                 cream sections. */}
      <ToolComparison data-id="element-9457" data-mp="tejxj76sw3yg" />
      <WallOfLove data-id="element-9458" data-mp="tg4raulajiv9" />
      <NarrativeSection data-id="element-9459" data-mp="ofqk1erikcya" />
      {/* <PricingSection /> Hidden from home for now — still a waitlist. Kept
                                                                                   for reuse; bring back when pricing goes live. */}
      <ClosingCTA data-id="element-9460" data-mp="1h57boa7b7ptg" />
    </>;
}